import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import FancyDropdown, {
  FancyDropdownToggle,
  FancyDropdownMenu,
  FancyDropdownMenuItem
} from 'dpl/components/FancyDropdown';
import Icon from 'dpl/common/components/Icon';

export default function MagazineHeaderNavigationLinksMobile({ links }) {
  const surfacedLinksCount = isLessThanBreakpoint('md') ? 2 : 3;
  const surfacedLinks = links.slice(0, surfacedLinksCount);
  const menuLinks = links.slice(surfacedLinksCount);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="PrismicMagazineHeaderNavigationLinksMobile f2 pt4 flex align-items-center justify-between">
      {surfacedLinks.map(({ href, title }) => (
        <a className="fw-medium" href={href} key={href}>
          {title}
        </a>
      ))}
      {menuLinks.length > 0 && (
        <FancyDropdown
          isOpen={isOpen}
          onChange={() => setIsOpen(!isOpen)}
          menuPosition="right"
        >
          <FancyDropdownToggle>
            <span className="flex fw-medium">
              <span>More</span>
              <Icon
                height="20px"
                name={`fat-arrow-${isOpen ? 'up' : 'down'}`}
                width="20px"
              />
            </span>
          </FancyDropdownToggle>
          <FancyDropdownMenu contentClassName="PrismicMagazineHeaderNavigationLinksMobile__menu absolute top-1 right-0 pv4 ph2 bg-purple br1 tl">
            {menuLinks.map(({ href, title }) => (
              <FancyDropdownMenuItem
                className="pv4 ph4 bg-transparent white"
                key={href}
                itemKey={href}
              >
                <a className="fw-medium" href={href} key={href}>
                  {title}
                </a>
              </FancyDropdownMenuItem>
            ))}
          </FancyDropdownMenu>
        </FancyDropdown>
      )}
    </nav>
  );
}

MagazineHeaderNavigationLinksMobile.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      title: PropTypes.string
    })
  ).isRequired
};
